import React from "react";
import "./ContactStyle.css";
import Footer from "./Footer";
import NotHomePageNavBar from "./NotHomePageNavBar";



const Contact = () => (
    <div>
    <NotHomePageNavBar />
    <div className="contact">
    
      <div className="info">
      <h2>Contact Information:</h2>
      <h3>Phone: 360-325-1819</h3>
      <h3>Email: jennydetmering@petaltech.solutions</h3>
      <a href="mailto:jennydetmering@petaltech.solutions?Subject=Hello%20again" target="_top">Send Email</a>
      </div>
      
      </div>
      <div>
      <Footer />
  </div>
  </div>
);

export default Contact;
